import { pencilIcon } from '@progress/kendo-svg-icons';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionModel } from 'app/models/session.model';
import { EventService } from 'app/core/services/event.service';
import { MembershipService } from 'app/core/services/membership.service';
import { ExpectedBillModel } from 'app/models/expected-bill.model';

@Component({
  standalone: false,
  selector: 'app-expected-bills',
  templateUrl: './expected-bills.component.html',
  styleUrls: ['./expected-bills.component.scss']
})
export class ExpectedBillsComponent implements OnInit {
  pencilIcon = pencilIcon;
  public session: SessionModel = null;
  public expected_bill_model: Array<ExpectedBillModel>;

  constructor(private route: ActivatedRoute, private membership: MembershipService, private event_service: EventService) {
    this.event_service.on('session-start', (model) => {
      this.session = model;
    });
    this.event_service.on('session-end', () => {
      this.session = null;
    });
  }

  ngOnInit(): void {
    this.membership.GetSession().subscribe(
      data => {
        this.session = data;
      },
      error => {
        this.session = null;
      });
      
    this.route.data.subscribe(({ expected_bill_model }) => {
      this.expected_bill_model = expected_bill_model;
    });
  }
}